import React, { useContext } from 'react';
import { Grid, Card, Pagination } from 'semantic-ui-react';
import ExpertCard from '../components/Experts/ExpertCard';
import SearchContext, { SearchProvider } from '../contexts/SearchContext';
import Filters from '../components/Search/Filters';
import Terms from '../components/Search/Terms';

const SearchPage = () => {
  const {
    searchResult, queries, page, paginate,
  } = useContext(SearchContext);

  if (!queries || queries.length === 0) return <div>No search term.</div>;

  const totalPages = Math.ceil(searchResult.total / 9);

  const renderExperts = () => (
    <Card.Group itemsPerRow={3} stackable>
      {searchResult.items.map((e) => <ExpertCard key={e.item.id} expert={e.item} />)}
    </Card.Group>
  );

  return (
    <Grid stackable id="search">
      <Grid.Row className="stats">
        {`Showing ${searchResult.total} results`}
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4} id="search-inputs">
          <Terms />
          <Filters />
        </Grid.Column>
        <Grid.Column width={12} id="search-results">
          <Grid>
            <Grid.Column>
              {renderExperts()}
            </Grid.Column>
          </Grid>
          <div className="pagination">
            <Pagination
              defaultActivePage={page}
              totalPages={totalPages}
              onPageChange={(e, d) => paginate(d.activePage)}
            />
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const Search = () => (
  <SearchProvider>
    <SearchPage />
  </SearchProvider>
);

export default Search;
